import axiosClient from './axios-client';
import getAffiliateId from '../utils/get_affiliate_id';

const URL = '/wp-admin/admin-ajax.php';

const visitsApi = {
  getVisits: async (affID, page = 1, module_name = 'visits') => {
    const affiliate_id = getAffiliateId();
    const data = new FormData();
    data.append('action', 'affiliate_dashboard');
    data.append('module', module_name);
    data.append('page', page);
    data.append('affiliate_id', affiliate_id || affID);
    const response = await axiosClient.post(URL, data);
    return response;
  },
}

export default visitsApi;
